import { svgIcons } from "utility/svgIcons";
const {
  IconMembers,
  // IconSubscriptions,
  IconIntegrations,
  IconDashboard,
} = svgIcons();

const CORPORATE_APP_PREFIX_URL = "/client";

/**
 * Stable identity for an entry the sidebar gates on. Not the label, which is
 * translated, so it differs per locale and changes whenever the copy does.
 */
export type SidebarGate = "companyDashboard";

interface CSSidebarItem {
  title: string;
  labelKey: string;
  path: string;
  imgName: string;
  cName: string;
  color: string;
  gate?: SidebarGate;
  subNav?: any;
}
interface CSSidebarItems extends Array<CSSidebarItem> {}
const CompanySidebarData: CSSidebarItems = [
  // {
  //   title: "Subscription",
  //   path: `${CORPORATE_APP_PREFIX_URL}/subscription`,
  //   imgName: IconSubscriptions,
  //   cName: "nav-text",
  //   color: "pink",
  // },
  {
    title: "Company Dashboard",
    labelKey: "admin:nav.companyDashboard",
    path: `${CORPORATE_APP_PREFIX_URL}/company-dashboard`,
    imgName: IconDashboard,
    cName: "nav-text",
    color: "pink",
    gate: "companyDashboard",
  },
  {
    title: "Members",
    labelKey: "admin:nav.members",
    path: `${CORPORATE_APP_PREFIX_URL}/members`,
    imgName: IconMembers,
    cName: "nav-text",
    color: "pink",
  },
  {
    title: "Integrations",
    labelKey: "admin:nav.integrations",
    path: `${CORPORATE_APP_PREFIX_URL}/integrations`,
    imgName: IconIntegrations,
    cName: "nav-text",
    color: "pink",
  },
  // {
  //   title: "Company Details",
  //   path: `${CORPORATE_APP_PREFIX_URL}/company-details`,
  //   imgName: IconCompanyDetails,
  //   cName: "nav-text",
  //   color: "pink",
  //   subNav:{title: "Integrations",
  //   path: `${CORPORATE_APP_PREFIX_URL}/Integrations`,
  //   imgName: IconCompanyDetails,
  //   cName: "nav-text",
  //   color: "pink",}
  // },
  /* {
    title: "Admin Settings",
    path: `${CORPORATE_APP_PREFIX_URL}/admin-settings`,
    imgName: ProfileIcon,
    cName: "nav-text",
  }, */
];
export default CompanySidebarData;
